import '@/modules/global';
import { Header, StickyHeader } from '@/modules/header';
import PredictiveSearch from '@/modules/predictive-search';
import CartNotification from '@/modules/cart-notification';
import CartBundle from '@/modules/cart-bundle';
import ResponsiveVideo from '@/modules/responsive-video';
import LazyVideo from '@/modules/lazy-video';
import FeaturedCollectionsSlider from '@/modules/featured-collections';
import MediaGridSlider from '@/modules/media-grid';
import ProductCarousel from '@/modules/product-carousel';
import ProductCarouselToggle from '@/modules/product-carousel-toggle';
import NewsCarousel from '@/modules/news-carousel';
import HalfWidthCarousel from '@/modules/half-width-carousel';
import MediaCarousel from '@/modules/media-carousel';
import SocialMediaCarousel from '@/modules/social-media-carousel';
import LogoGrid from '@/modules/logo-grid';
import SquareMediaContentGrid from '@/modules/square-media-content-grid';
import FeaturedIconCarousel from '@/modules/featured-icon-carousel';
import AnnouncementCarousel from '@/modules/announcement-carousel';
import TabbedMediaContent from '@/modules/tabbed-media-content';
import ModalContentCarousel from '@/modules/modal-content-carousel';

import '@/modules/accordion';
import KeyboardFocus from '@/modules/keyboard-focus/keyboard-focus';
import CartCrossSellCarousel from '@/modules/cart-cross-sell-carousel';

const responsiveVideos = document.querySelectorAll('.js-responsive-video');
if (responsiveVideos) {
    Array.from(responsiveVideos).forEach(el => new ResponsiveVideo(el));
}

const lazyVideos = document.querySelectorAll('.js-lazy-video');
if (lazyVideos) {
    new LazyVideo(lazyVideos);
}

new Header();

if (document.getElementsByTagName('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
}

if (document.getElementsByTagName('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
}

if (document.getElementsByTagName('cart-notification')?.length > 0) {
    customElements.define('cart-notification', CartNotification);
    
    const bundleOverlays = document.querySelectorAll('.js-bundle-overlay');
    if (bundleOverlays) {
        customElements.define('cart-bundle', CartBundle);
    }
}

const collectionSliders = document.querySelectorAll('.js-featured-collections-slider');
if (collectionSliders) {
    collectionSliders.forEach(el => new FeaturedCollectionsSlider(el));
}

const mediaGridSliders = document.querySelectorAll('.js-media-grid-slider');
if (mediaGridSliders) {
    mediaGridSliders.forEach(el => new MediaGridSlider(el));
}

const productSliders = document.querySelectorAll('.js-product-carousel');
if (productSliders) {
    productSliders.forEach(el => new ProductCarousel(el));
}

const productToggleSliders = document.querySelectorAll('.js-product-carousel-toggle');
if (productToggleSliders) {
    productToggleSliders.forEach(el => new ProductCarouselToggle(el));
}

const newsSliders = document.querySelectorAll('.js-news-carousel');
if (newsSliders) {
    newsSliders.forEach(el => new NewsCarousel(el));
}

const halfWidthCarousel = document.querySelectorAll('.js-half-width-carousel');
if (halfWidthCarousel) {
    halfWidthCarousel.forEach(el => new HalfWidthCarousel(el));
}

const mediaCarousel = document.querySelectorAll('.js-media-carousel');
if (mediaCarousel) {
    mediaCarousel.forEach(el => new MediaCarousel(el));
}

const socialMediaCarousel = document.querySelectorAll('.js-social-media');
if (socialMediaCarousel) {
    socialMediaCarousel.forEach(el => new SocialMediaCarousel(el));
}

const logoGrid = document.querySelectorAll('.js-logo-grid');
if (logoGrid) {
    logoGrid.forEach(el => new LogoGrid(el));
}

const squareMediaContentGrid = document.querySelectorAll('.js-square-media-content-grid');
if (squareMediaContentGrid) {
    squareMediaContentGrid.forEach(el => new SquareMediaContentGrid(el));
}

const featuredIconsSliders = document.querySelectorAll('.js-featured-icons-carousel');
if (featuredIconsSliders) {
    featuredIconsSliders.forEach(el => new FeaturedIconCarousel(el));
}

const announcementCarousels = document.querySelectorAll('.js-announcement-carousel');
if (announcementCarousels) {
    announcementCarousels.forEach(el => new AnnouncementCarousel(el));
}

const tabbedContentCarousels = document.querySelectorAll('.js-tabbed-media-content');
if (tabbedContentCarousels) {
    tabbedContentCarousels.forEach(el => new TabbedMediaContent(el));
}

const modalContentCarousels = document.querySelectorAll('.js-modal-content-carousel');
if (modalContentCarousels.length) {
    modalContentCarousels.forEach(el => new ModalContentCarousel(el));
}

const crossSellCarousels = document.querySelectorAll('.js-cart-cross-sell-carousel');
if (crossSellCarousels) {
    crossSellCarousels.forEach(el => new CartCrossSellCarousel(el));
}

new KeyboardFocus();
